// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import _, { get, merge, find } from 'lodash';
import { push } from 'react-router-redux';
import phoneify from 'phoneify';

@connect((store, props) => ({
  user: store.user,
  staticData: store.staticData,
}))
export default class UserAlertDetail extends Component {

  static propTypes = {
    user: PropTypes.object.isRequired,
    detail: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired
  }

  render() {

    let detail = this.props.detail;

    return (

        <div className='user-alert-detail'>
         <div className='alert-contact-info'>
               <div data-id='selected-status'>{find(this.props.staticData.contactStatus, (status) => status.id == detail.profile.contactStatus).name}</div>
               <div className='notification-link'
                data-id='selected-name'
                onClick={(e) => this.props.dispatch(push(`/admin/contacts/${detail.profile.id}/details`))}>
                  {detail.user.firstName} {detail.user.lastName}
              </div>
             <div data-id='selected-company-name'>{detail.company.name}</div>
               <div data-id='selected-phone'>{detail.user.phoneNumber1 && phoneify(detail.user.phoneNumber1).countryCodeRemoved.addTrailingSlashes}</div>
              <div data-id='selected-email'>{detail.user.email}</div>
            </div>
          <br />
           <div className='alert-additional-info'>
              <div data-id='selected-offices'>{detail.company.numberOfOffices} Offices</div>
              <div data-id='selected-parent'>{detail.company.parentCompany}</div>
              <div data-id='selected-types'>{detail.company.industryTypes.map(v => find(this.props.staticData.industryTypesList, i => i.value == v).name).join(', ')}</div>
              <br />
              <div data-id='selected-inquiry'>Inquiry Reason:<br/>{detail.profile.initialInquiry}</div>
            </div>
          </div>

    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/Alerts/UserAlertDetail/index.js